<template>
    <div>
        <div class="popup_st02">
            <div :class="wrapClass">
                <div class="title">
                    <span class="ict_btn blue">{{ accidentTypeName }}</span>
                    <span class="t01">{{ dongName }}</span>
                </div>

                <div class="pop_table03">
                    <table>
                        <caption>돌발리스트</caption>
                        <colgroup>
                            <col style="width: 25%;"/>
                            <col style="width: 75%;"/>
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>발생일시</th>
                            <td><span class="t_red">{{ accidentFormatDate(accidentInfo.basdtVal) }}</span></td>
                        </tr>
                        <tr>
                            <th>종료일시</th>
                            <td><span class="t_red">{{ accidentFormatDate(accidentInfo.val14) }}</span></td>
                        </tr>
                        <tr>
                            <th>상세내용</th>
                            <td><span>{{ accidentInfo.val12 }}</span></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { $_WC, $_TYPE } from "@/confs/common.const.js";
import gripUtil from '@/libs/grip.util.js';

export default {
    name: "AccidentInfoWin",
    data() {
        return {
            accidentInfo: {},
        };
    },
    props: {
        wrapClass: {
            type: String,
            default: 'popup_wrap'
        }
    },
    computed: {
        ...mapGetters({
            accidentTypeCodeMap: 'getAccidentTypeCodeMap',
        }),
        accidentTypeName() {
            let accidentInfo = this.accidentInfo;

            if(typeof accidentInfo === $_TYPE.UNDEF ||
                typeof accidentInfo.val2 === $_TYPE.UNDEF ||
                typeof this.accidentTypeCodeMap[accidentInfo.val2] === $_TYPE.UNDEF) {
                return "";
            } else {
                return this.accidentTypeCodeMap[accidentInfo.val2];
            }
        },
        dongName() {
            let accidentInfo = this.accidentInfo;
            let addressArr = ['', ''];
            if(typeof accidentInfo !== 'undefined' && typeof accidentInfo.val4 !== $_TYPE.UNDEF) {
                addressArr = accidentInfo.val4.split(' ');
            }

            return addressArr[2] + " " + addressArr[3];
        }
    },
    updated() {
        this.$emit('loaded-accident-info', this.$el.innerHTML);
    },
    methods: {
        setAccidentInfo(accidentInfo) {
            this.accidentInfo = Object.assign({}, accidentInfo);
        },
        accidentFormatDate(val) {
            if(typeof val === $_TYPE.UNDEF) {
                return "-";
            }
            return gripUtil.formatDate(val.replace(/년|월|일|시|분|\s/gi, ""), "yyyy.MM.dd HH:mm", "-");
        },
    }
}
</script>
